import { getForms } from "../../../services/forms.services";
import { useEffect, useState } from "react";
import { IForms } from "../../../types/forms";
import ReactPagination from "../../Common/ReactPagination";
import Loading from "../../Common/LoadingScreen";
import { useNavigate } from "react-router-dom";
import Moment from "moment";
import deleteDataByID from "../../../services/delete.services";

import Modal from "react-modal";
import { jwtDecode } from "jwt-decode";
import downloadAsFiles from "../../../services/download.services";

export const SyllabusList = (): JSX.Element => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [Syllabus, setSyllabus] = useState<any>();
  const [limit, setLimit] = useState<number>(15);
  const [offset, setOffSet] = useState<number>(0);
  const [search, setSearch] = useState<string>("");
  const [buttonDisable, setButtonDisable] = useState<boolean>(false);

  const [selectedData, setSelectedData] = useState<any>([]);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState<boolean>(false);

  const [deleteDataByIDModal, setDeleteDataByIDModal] = useState(false);
  const [dataID, setDataID] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const handleModal = () => setDeleteDataByIDModal(!deleteDataByIDModal);

  const deleteValue = (id: any, firstName: any, lastName: any) => {
    setFirstName(firstName);
    setLastName(lastName);
    setDataID(id);
  };

  const tokenInfo: any = jwtDecode(
    localStorage.getItem("access_token") as string
  );

  const handleDelete = async (id: any) => {
    try {
      deleteDataByID(id);
      handleModal();
      getSyllabus();
    } catch (e: any) {
      if (!e.statusCode) {
        localStorage.removeItem("access_token");
        navigate("/");
      }
    }
  };

  useEffect(() => {
    getSyllabus();
  }, [offset, limit, search]);

  const getSyllabus = async () => {
    const getFormsArgs = {
      formTypeId: 6,
      limit: limit,
      offset: offset,
      name: search,
    };
    try {
      const allsyllabus = await getForms(getFormsArgs);
      setSyllabus(allsyllabus.data);
      setIsLoading(false);
    } catch (e: any) {
      if (!e.statusCode) {
        localStorage.removeItem("access_token");
        navigate("/");
      }
    }
  };

  useEffect(() => {
    // console.log('Syllabus: ', Syllabus?.data);

    const includes = Syllabus?.data.every((syllabus: any) => {
      return selectedData?.some((selected: any) => selected.id === syllabus.id);
    });

    includes ? setIsSelectAllChecked(true) : setIsSelectAllChecked(false);
  }, [Syllabus?.data]);

  const handleInput = (event: any) => {
    setSearch(event.target.value);
  };

  const handleDownload = async () => {
    setButtonDisable(true);
    const fileData = await downloadAsFiles("formTypeId=6");
    // const blob = new Blob([fileData.data], { type: 'text/csv;charset=utf-8;' });

    const selectedFileData = await downloadAsFiles(
      `formTypeId=6${selectedData
        .map((item: any) => `&selectedId=${item.id}`)
        .join("")}`
    );

    let blob: any;
    if (selectedData) {
      blob = new Blob([selectedFileData.data], {
        type: "text/csv;charset=utf-8;",
      });
    } else {
      blob = new Blob([fileData.data], { type: "text/csv;charset=utf-8;" });
    }

    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "syllabus.csv");
    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
    setButtonDisable(false);

    getSyllabus();
  };

  const handleChange = (e: any) => {
    const { id, checked } = e.target;

    let filteredCheckedData: any = [];
    let allCheckedData: any = [];

    if (id === "selectAll") {
      if (
        checked &&
        !Syllabus?.data.every((syllabus: any) => {
          return selectedData?.some(
            (selected: any) => selected.id === syllabus.id
          );
        })
      ) {
        allCheckedData = [
          ...selectedData,
          ...Syllabus?.data.map((syllabus: any) => ({
            ...syllabus,
            // checked: true,
          })),
        ];
      } else if (
        !checked &&
        Syllabus?.data.every((syllabus: any) => {
          return selectedData?.some(
            (selected: any) => selected.id === syllabus.id
          );
        })
      ) {
        allCheckedData = selectedData?.filter(
          (data: any) =>
            !Syllabus?.data.some(
              (syllabus: any) =>
                syllabus.id === data.id && syllabus.name === data.name
            )
        );
      }

      if (allCheckedData.length > 0) {
        filteredCheckedData = allCheckedData?.filter(
          (dataItem: any, index: any, self: any) =>
            index ===
            self.findIndex(
              (i: any) => i.id === dataItem.id && i.name === dataItem.name
            )
        );
        setSelectedData(filteredCheckedData);
      } else {
        setSelectedData(allCheckedData);
      }
      setIsSelectAllChecked(checked);
    } else {
      const updatedSelectedData = checked
        ? [
          ...selectedData,
          Syllabus?.data.find((syllabus: any) => syllabus.id === Number(id)),
        ]
        : selectedData?.filter((contact: any) => contact.id !== Number(id));

      // console.log('Updated Selected Data', updatedSelectedData);

      setSelectedData(updatedSelectedData);

      Syllabus?.data.every((syllabus: any) => {
        return updatedSelectedData?.some(
          (element: any) => element.id === syllabus.id
        );
      })
        ? setIsSelectAllChecked(true)
        : setIsSelectAllChecked(false);
    }
  };

  return (
    <>
      <section className="main-container">
        <div className="top-section align-items-center row">
          <div className="col-md-7 col-xl-8">
            <div className="xlarge-text-size">Download Syllabus</div>
          </div>
          <div className="col-md-3 col-xl-2 text-right">
            <input
              value={search}
              onChange={handleInput}
              placeholder="Search by name"
            />
          </div>
          <div className="col-md-2 text-right">
            <button
              type="button"
              className="btn"
              onClick={handleDownload}
              disabled={buttonDisable}
            >
              Download{" "}
              {selectedData?.length === 0 ? "all" : selectedData?.length}
            </button>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="table-responsive">
              {isLoading && <Loading />}
              <table className="table">
                <thead>
                  <tr>
                    <th className="xs">
                      <input
                        type="checkbox"
                        id="selectAll"
                        onChange={handleChange}
                        checked={isSelectAllChecked}
                      />
                    </th>
                    <th className="xs">S.No.</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Pdf Download</th>
                    <th>Country</th>
                    <th className="sm">Source</th>
                    <th className="sm">Medium</th>
                    <th className="sm">Campaign</th>
                    <th className="sm">Content</th>
                    <th>Submitted on</th>
                    {tokenInfo.permissions[0] === "Delete" ? (
                      <th className="xs">Action</th>
                    ) : (
                      ""
                    )}
                  </tr>
                </thead>
                <tbody>
                  {Syllabus?.data === ""
                    ? "Empty data"
                    : Syllabus?.data.map((syllabus: IForms, index: any) => {
                      return (
                        <tr key={syllabus.id}>
                          <td>
                            <input
                              type="checkbox"
                              id={JSON.stringify(syllabus.id)}
                              checked={selectedData?.some(
                                (item: any) => item.id === syllabus.id
                              )}
                              onChange={handleChange}
                            />
                          </td>
                          <td>
                            <span>{index + 1 + offset}</span>
                          </td>
                          <td>
                            {syllabus.firstName !== "." ? (
                              <>
                                <span>{syllabus.firstName}</span>{" "}
                                <span>{syllabus.lastName}</span>
                              </>
                            ) : (
                              <span>{syllabus.fullName}</span>
                            )}
                          </td>
                          <td>
                            <span>{syllabus.email}</span>
                          </td>
                          <td>
                            <span>{syllabus.downloadFileName}</span>
                          </td>
                          <td>
                            <span>{syllabus.country}</span>
                          </td>
                          <td className="sm">
                            <span>{syllabus.utmSource}</span>
                          </td>
                          <td className="sm">
                            <span>{syllabus.utmMedium}</span>
                          </td>
                          <td className="sm">
                            <span>{syllabus.utmCampaign}</span>
                          </td>
                          <td className="sm">
                            <span>{syllabus.utmContent}</span>
                          </td>
                          <td className="sm">
                            <span className="">
                              {Moment(syllabus.createdAt).format(
                                "ddd, MMM Do YYYY, h:mm:ss a"
                              )}
                            </span>
                          </td>
                          {tokenInfo.permissions[0] === "Delete" ? (
                            <>
                              <td className="xs">
                                <button
                                  className="btn-danger btn"
                                  type="button"
                                  onClick={() => {
                                    handleModal();
                                    deleteValue(
                                      syllabus.id,
                                      syllabus.lastName,
                                      syllabus.firstName
                                    );
                                  }}
                                >
                                  Delete
                                </button>
                              </td>{" "}
                            </>
                          ) : (
                            ""
                          )}
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>

            <ReactPagination
              totalData={Syllabus}
              setLimit={setLimit}
              setOffSet={setOffSet}
              limit={limit}
            />
          </div>
        </div>
      </section>

      <Modal
        isOpen={deleteDataByIDModal}
        onRequestClose={handleModal}
        contentLabel="delete-data"
      >
        <div className="head">
          <h4>Remove data</h4>
        </div>
        <div className="m-body">
          <div>
            Are you sure you want to remove this{" "}
            <b>
              {firstName} {lastName}
            </b>{" "}
            data
          </div>
        </div>
        <div className="m-footer">
          <button className="btn btn-link" onClick={handleModal}>
            Close
          </button>{" "}
          {"  "}
          <button
            className="btn btn-danger"
            onClick={() => handleDelete(dataID)}
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};
